"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCurrentIndex = void 0;
var _react = require("react");
var _TaskManager = require("../TaskManager.provider");
const useCurrentIndex = (audiencePickerProvider, isNoAudienceEnabled, itemID, taskID, onStatusChange) => {
  const {
    isUpdate,
    isUnitDataError,
    task,
    taskError,
    isCloneItemError,
    isShareItem,
    isSavedItem,
    isSaveItemError,
    isEditTaskDataOpened,
    updateTaskTypeAfterExamStart,
    reSubmitTaskAfterTaskTypeChanged
  } = (0, _react.useContext)(_TaskManager.TaskManagerContext);
  const getCurrentIndex = (0, _react.useCallback)(() => {
    if (isUnitDataError || taskError || isCloneItemError || isSaveItemError) {
      return 9;
    }
    if (audiencePickerProvider.isNoAudience && !isNoAudienceEnabled) {
      return 12;
    }
    if (!(itemID || taskID) && !task?.item) {
      return 0;
    }
    if (isShareItem) {
      return 8;
    }
    if (isSavedItem) {
      return 7;
    }
    if (isEditTaskDataOpened) {
      return 6;
    }
    if (updateTaskTypeAfterExamStart) {
      return 10;
    }
    if (reSubmitTaskAfterTaskTypeChanged) {
      return 11;
    }
    const audiencePickerIndexMapper = {
      inline: 1,
      groupsSelector: 2,
      studentsSelector: 3,
      createGroup: 4,
      groupEdit: 5
    };
    return audiencePickerIndexMapper[audiencePickerProvider.view];
  }, [audiencePickerProvider.isNoAudience, audiencePickerProvider.view, isCloneItemError, isEditTaskDataOpened, isNoAudienceEnabled, isSaveItemError, isSavedItem, isShareItem, isUnitDataError, itemID, reSubmitTaskAfterTaskTypeChanged, task?.item, taskError, taskID, updateTaskTypeAfterExamStart]);
  (0, _react.useEffect)(() => {
    if (onStatusChange) {
      const index = getCurrentIndex();
      let status = '';
      switch (index) {
        case 0:
          status = 'select_item';
          break;
        case 9:
          status = 'error';
          break;
        case 7:
        case 8:
          status = 'success';
          break;
        default:
          status = isUpdate ? 'update_task' : 'create_new_task';
          break;
      }
      onStatusChange(status);
    }
  }, [getCurrentIndex, isUpdate, onStatusChange]);
  return {
    getCurrentIndex
  };
};
exports.useCurrentIndex = useCurrentIndex;